export default {
  backend: process.env.BACKEND_URL || "http://visp.vostro.loc:7082/",
  portal: process.env.PORTAL_URL || "/portal",
  auth: process.env.AUTH_URL || "",
}